import React from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import TabsCst from "@components/TabsCst";
import {
  EnrollmentTargetKind,
  EnrollmentTargetsState,
  EnrollmentTriggerPayload,
  SelectedTargetItem,
} from "../types";
import UsersTab from "./tabs/UsersTab";
import GroupsTab from "./tabs/GroupsTab";
import InitiativesTab from "./tabs/InitiativesTab";

interface TargetSelectionStepProps {
  trigger: EnrollmentTriggerPayload;
  activeKind: EnrollmentTargetKind;
  onActiveKindChange: (next: EnrollmentTargetKind) => void;
  targets: EnrollmentTargetsState;
  onTargetsChange: (
    kind: EnrollmentTargetKind,
    items: SelectedTargetItem[],
  ) => void;
}

const TargetSelectionStep: React.FC<TargetSelectionStepProps> = ({
  trigger,
  activeKind,
  onActiveKindChange,
  targets,
  onTargetsChange,
}) => {
  const { t } = useTranslation("enrollment-modal");

  const tabs = [
    { key: "users", label: t("tabs.users") || "Utenti" },
    { key: "groups", label: t("tabs.groups") || "Gruppi" },
    { key: "initiatives", label: t("tabs.initiatives") || "Intera iniziativa" },
  ];

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <TabsCst
        tabs={tabs}
        activeKey={activeKind}
        onChange={(k) => onActiveKindChange(k as EnrollmentTargetKind)}
      />

      {activeKind === "users" && (
        <UsersTab
          corporateId={trigger.corporateId}
          selected={targets.users}
          onChange={(items) => onTargetsChange("users", items)}
        />
      )}
      {activeKind === "groups" && (
        <GroupsTab
          corporateId={trigger.corporateId}
          selected={targets.groups}
          onChange={(items) => onTargetsChange("groups", items)}
        />
      )}
      {activeKind === "initiatives" && (
        <InitiativesTab
          corporateId={trigger.corporateId}
          selected={targets.initiatives}
          onChange={(items) => onTargetsChange("initiatives", items)}
        />
      )}
    </Box>
  );
};

export default TargetSelectionStep;
